/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CollectionModelUserActionResponse } from '../models/CollectionModelUserActionResponse';
import type { UserActionRequest } from '../models/UserActionRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserActionControllerService {

  /**
   * Trace a relevant user action on the db for audit purpose, like an insert, update, or something else
   * @returns CollectionModelUserActionResponse The traced user action with its assigned id
   * @throws ApiError
   */
  public static addUserAction({
requestBody,
}: {
requestBody: UserActionRequest,
}): CancelablePromise<CollectionModelUserActionResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/user-action',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

}
